export default "__VITE_ASSET__Cs4Zo$rJ__"